/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ExternalContainerLocationPhysicalStatusListQueryVariables = {};
export type ExternalContainerLocationPhysicalStatusListQueryResponse = {
    readonly v2PhysicalStatusList: ReadonlyArray<{
        readonly slug: string;
        readonly name: string;
    }>;
};
export type ExternalContainerLocationPhysicalStatusListQuery = {
    readonly response: ExternalContainerLocationPhysicalStatusListQueryResponse;
    readonly variables: ExternalContainerLocationPhysicalStatusListQueryVariables;
};



/*
query ExternalContainerLocationPhysicalStatusListQuery {
  v2PhysicalStatusList {
    slug
    name
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PhysicalStatusResult",
    "kind": "LinkedField",
    "name": "v2PhysicalStatusList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalContainerLocationPhysicalStatusListQuery",
    "selections": (v0/*: any*/),
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ExternalContainerLocationPhysicalStatusListQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e6584111d55fe6603e594f490498b450",
    "id": null,
    "metadata": {},
    "name": "ExternalContainerLocationPhysicalStatusListQuery",
    "operationKind": "query",
    "text": "query ExternalContainerLocationPhysicalStatusListQuery {\n  v2PhysicalStatusList {\n    slug\n    name\n  }\n}\n"
  }
};
})();
(node as any).hash = '032a1801d60ecc199cf380d6e2371fca';
export default node;
